import { IServicePeriods } from "./models";

export const serviceTypes = [
  {
    id: "1",
    label: "Ambos",
  },
  {
    id: "2",
    label: "Externo",
  },
  {
    id: "3",
    label: "Internado",
  },
  {
    id: "4",
    label: "Pronto Socorro",
  },
  {
    id: "5",
    label: "Telesaúde",
  },
  {
    id: "6",
    label: "Ambulatorial",
  },
  {
    id: "7",
    label: "Atendimento Domiciliar",
  },
  {
    id: "8",
    label: "Caso de Urgência",
  },
];

export const servicePeriodItems: IServicePeriods[] = [
  {
    id: "1",
    startDate: "2026-02-02",
    endDate: "2026-02-03",
    serviceType: [serviceTypes[0].label, serviceTypes[1].label],
  },
  {
    id: "2",
    startDate: "2026-02-03",
    endDate: "2026-02-04",
    serviceType: [
      serviceTypes[2].label,
      serviceTypes[3].label,
      serviceTypes[4].label,
    ],
  },
  {
    id: "3",
    startDate: "2026-02-04",
    endDate: "2026-02-06",
    serviceType: [
      serviceTypes[5].label,
      serviceTypes[6].label,
      serviceTypes[7].label,
    ],
  },
];
